import React from 'react';
import { useNavigate } from 'react-router-dom';
import ProductListingPage from '../components/ProductListingPage';
import retailProducts from '../data/retailProducts';

const retailCategories = ['All', 'Saffron', 'Ginger', 'Turmeric', 'Chilli', 'Seeds & Spices', 'Cardamom', 'Masala'];

function RetailProductsPage() {
  const navigate = useNavigate();
  return (
    <ProductListingPage
      title="RETAIL"
      subtitle="PRODUCTS"
      products={retailProducts}
      categories={retailCategories}
      titleColor="#FFFFFF"
      backButtonPosition="right"
      contentTopPadding={{ xs: 1, md: 2 }}
      backButtonMarginBottom={1}
      headerInline
      onProductClick={(product) => navigate(`/products/retail/${product.id}`)}
    />
  );
}

export default RetailProductsPage;